export default __webpack_public_path__ + "static/worker5-9d1c88fc595179b8ddec24732836271e.jpg";